import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=19b5032b"
import script from "./scroll-to-top.vue?vue&type=script&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports